/**
 * FooterSection — Free-form rich text + social icon+name links. v2
 * Layout: centered rich-text content → social links row (icon + platform name).
 * All editing lives in the settings panel. Canvas is read-only.
 * Default background: #f4efe5
 */
import React from 'react';
import { Linkedin, Instagram, Twitter, Facebook, Youtube, Globe } from 'lucide-react';

const PLATFORM_ICONS = {
  LinkedIn:  Linkedin,
  Instagram: Instagram,
  Twitter:   Twitter,
  Facebook:  Facebook,
  YouTube:   Youtube,
  Website:   Globe,
};

export function FooterSection({ section, isSelected }) {
  const data = section.data     || {};
  const st   = section.settings || {};

  const contentHtml = data.contentHtml ?? '';
  const socialLinks = (data.socialLinks ?? []).filter((l) => l.url);

  const bg      = st.backgroundColor || '#f4efe5';
  const textCol = st.textColor        || '#000000';
  const padding = st.padding          || '32px';

  return (
    <div style={{ padding, backgroundColor: bg, textAlign: 'center' }}>

      {/* ── Rich text content ─────────────────────────────────── */}
      <style>{`
        .footer-content ul { padding-left: 1.5em; list-style-type: disc; margin: 0.3em 0; }
        .footer-content ol { padding-left: 1.5em; list-style-type: decimal; margin: 0.3em 0; }
        .footer-content li { margin-bottom: 0.2em; }
        .footer-content p  { margin: 0 0 0.3em; }
      `}</style>
      {contentHtml ? (
        <div
          className="footer-content"
          style={{
            fontSize: 14, color: textCol, lineHeight: 1.7,
            marginBottom: socialLinks.length > 0 ? 16 : 0,
          }}
          dangerouslySetInnerHTML={{ __html: contentHtml }}
        />
      ) : (
        isSelected && (
          <div style={{
            fontSize: 14, color: textCol + '88', fontStyle: 'italic',
            marginBottom: 16,
          }}>
            Add footer content in the settings panel
          </div>
        )
      )}

      {/* ── Social links row ──────────────────────────────────── */}
      {socialLinks.length > 0 && (
        <div style={{
          display: 'flex', justifyContent: 'center',
          flexWrap: 'wrap', gap: 20,
        }}>
          {socialLinks.map((link, i) => {
            const Icon = PLATFORM_ICONS[link.platform] || Globe;
            return (
              <a
                key={i}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  color: textCol, textDecoration: 'underline',
                  fontSize: 14, fontWeight: 500,
                }}
              >
                <Icon size={14} />
                {link.platform}
              </a>
            );
          })}
        </div>
      )}

      {/* Empty hint when no links and not selected */}
      {!contentHtml && socialLinks.length === 0 && !isSelected && (
        <div style={{ fontSize: 14, color: textCol + '66', fontStyle: 'italic' }}>
          Footer
        </div>
      )}
    </div>
  );
}
